document.addEventListener("DOMContentLoaded", function () {
  _uncs_virtualniProhlidyProdejnyDoNovehoOkna();
  _uncs_changeActiveClassColorFilterBox();
  _uncs_disableColorFilterBoxOnChange();
  
  //Zajisteni filtru pouze pro dostupne varianty
  //Prida do vsech odkazu parametr filter.v.availability=1
  _uncs_setAvailabilityFilterInCollectionLinks();
  
  //Zapne automaticky filtr filter.v.availability
  //_uncs_setAvailabilityFilterInCollection();

});

/**
 * Na stránce prodejen jsou tlačítka odkazující na virtuální prohlídky. Tyto tlačítka
 * jsou přidána přes wysiwyg editor a nelze jim tam přidat atribut target pro otevírání
 * do nového okna. Tento script tam tento atribut dodá.
 */
function _uncs_virtualniProhlidyProdejnyDoNovehoOkna() {
  var attrHref = "";
  var tlacitkaSOdkazy = document.querySelectorAll("a.button.button--primary"); //Najdi vsechna tlacitka s class .button.button--primary
  if (!tlacitkaSOdkazy) {
    return;
  }
  tlacitkaSOdkazy.forEach(function (tlacitko) {
    attrHref = tlacitko.getAttribute("href");
    if (attrHref.includes("system.uncs.eu")) {
      tlacitko.setAttribute("target", "_blank");
    }
  });
}

/**
 * Pouzito ve výpisech produktů z kolekce. V karte jsou nahledy barevnych variant, po kliknuti
 * na ne se vymeni hlavni obrazek karty a zmeni se url odkazu na konkretni barevnou variantu. Funkce
 * se vola v tagu img, atribute onload, ve fragmentu uncs-product-variant-thumbs.liquid
 */
function _uncs_changeVariantInCollectionsList(element) {
  _uncs_preloadImages(element);

  let newIdVariant = element.getAttribute("data-idVariant");
  let newUrlVariant = element.getAttribute("data-urlVariant");
  let newImgSrc = element.getAttribute("data-imgSrc");
  if (!newImgSrc) return;

  let baseNewImgSrc = newImgSrc.slice(0, newImgSrc.indexOf("?"));
  let parentLi = element.closest("li");
  if (!parentLi) return false;

  element.addEventListener("click", () => {
    parentLi.querySelectorAll("a").forEach((childA) => {
      childA.setAttribute("href", newUrlVariant);
    });

    let imgVariant = parentLi.querySelector("img.motion-reduce");
    if (!imgVariant) return;

    let imgSrc = imgVariant.getAttribute("src") || "";
    let baseImgSrc = imgSrc.slice(0, imgSrc.indexOf("?"));
    let imgSrcSet = imgVariant.getAttribute("srcset") || "";

    imgVariant.setAttribute("src", imgSrc.replace(baseImgSrc, baseNewImgSrc));
    imgVariant.setAttribute("srcset", imgSrcSet.replaceAll(baseImgSrc, baseNewImgSrc));

    return false;
  });
}

/**
 * preload obrazku variant. V pripade, ze by se stranky nacitala kvuli preloadu
 * nacitala dlouho, muze se jeji volani ve fn _uncs_changeVariantInCollectionsList() vypnout
 * @param {object} e - vsechny elementy obrazku/ nahledu variant (img.changeVariantInCollectionsList) v DOMu
 */
function _uncs_preloadImages(element) {
  let newImgSrc = element.getAttribute("data-imgSrc");
  if (!newImgSrc) return;

  let baseNewImgSrc = newImgSrc.slice(0, newImgSrc.indexOf("?"));
  let parentLi = element.closest("li");
  if (!parentLi) return;

  let imgVariant = parentLi.querySelector("img.motion-reduce");
  if (!imgVariant || !imgVariant.currentSrc) return;

  let imgSrc = imgVariant.currentSrc;
  let baseImgSrc = imgSrc.slice(0, imgSrc.indexOf("?"));

  // Preload images
  let img = new Image();
  img.src = imgSrc.replace(baseImgSrc, baseNewImgSrc);
}

/**
 * Pri filtrovani dle barev ma neaktivni ctverec tridu
 * .uncs-color-box a aktivni .uncs-color-box-active
 * Po kliknuti na ctverec barvy se musi tyto dve tridy vymenit
 */
function _uncs_changeActiveClassColorFilterBox() {
  let spans = document.querySelectorAll(
    "span.uncs-color-box, span.uncs-color-box-active"
  );
  if (!spans) {
    return;
  }
  spans.forEach(function (span) {
    span.addEventListener("click", function () {
      if (this.classList.contains("uncs-color-box")) {
        this.classList.remove("uncs-color-box");
        this.classList.add("uncs-color-box-active");
      } else if (this.classList.contains("uncs-color-box-active")) {
        this.classList.remove("uncs-color-box-active");
        this.classList.add("uncs-color-box");
      }
    });
  });
}


/*
Najde vsechny checkboxy filtru a na udalost change na ne navesi funkci _uncs_disableColorFilterBox()
*/
function _uncs_disableColorFilterBoxOnChange() {
  let checkboxes = document.querySelectorAll(
    'form#FacetFiltersForm fieldset label[for^="Filter-"] input[type="checkbox"]'
  );

  if (!checkboxes) return;
  checkboxes.forEach(function (checkbox) {
    if (!checkbox) return;
    checkbox.addEventListener("change", function () {
      setTimeout(function () {
        _uncs_disableColorFilterBox();
      }, 100);
    });
  });
}

/*
Pri zmene stavu checkboxu funkce projde vsechny checkboxy filtru a podiva se, zda je checkbox disabled (tento attribut meni Shopify)
Kdyz je disabled, najde nadrizeny prvek <li> a da mu css tridu uncs-filter-disabled. Tato trida cely checkbox schova
*/
function _uncs_disableColorFilterBox() {
  let checkboxes = document.querySelectorAll(
    'form#FacetFiltersForm fieldset label[for^="Filter-"] input[type="checkbox"]'
  );
  checkboxes.forEach(function (checkbox) {
    if (!checkbox) return;
    let li = document.querySelector(
      'li[data-uncs-idfilter="' + checkbox.getAttribute("id") + '"]'
    );
    if (!li) {
      return;
    }
    if (checkbox.disabled) {
      li.classList.add("uncs-filter-disabled");
    } else {
      li.classList.remove("uncs-filter-disabled");
    }
  });
}

/*
Kontrola CZ formatu tlf cisla
*/
function _uncs_isValidCZPhoneNumber(phone) {
  // Regulární výraz pro ověření formátu českého telefonního čísla
  var regex = /^(?:\+420|00420)?\s?\d{3}\s?\d{3}\s?\d{3}$/;
  return regex.test(phone);
}

/*
Kontrola formatu e-mailu
*/
function _uncs_isValidEmail(email) {
  // Regulární výraz pro ověření formátu e-mailové adresy
  var regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  return regex.test(email);
}

/*
Projde seznam selectoru uvedenych selectorStr, najde v nich odkazy obsahujici vyraz /collections/ a na nich
zavola funkci _uncs_modifyLinkAvailabilityFilter
*/
function _uncs_setAvailabilityFilterInCollectionLinks() {
  // you can change this selector based on your theme structure
  var selectorStr =
    "header a[href*='/collections/'], div.collection div a[href*='/collections/'], ul.uncs-sider-menu-list li a[href*='/collections/'], #uncs-breadcrumbs ol li a[href*='/collections/'], .drawer a[href*='/collections/']";
  selectorStr.split(",").forEach((selector) => {
    var selectorTrimmed = selector.trim();
    if (selectorTrimmed) {
      document
        .querySelectorAll(selectorTrimmed)
        .forEach(_uncs_modifyLinkAvailabilityFilter);
    }
  });
}

/*
Do predaneho odkazu prida na konec url parametr filter.v.availability=1,
ktery zajisti, ze se ve filtru velikosti nebudou nabizet moznosti
u vyprodanych variant
*/
function _uncs_modifyLinkAvailabilityFilter(link) {
  //Zda se, ze to jiz neni potreba
  //return;
  if (link.tagName !== "A") return;

  var url = new URL(link.href);
  if (!url.searchParams.has("filter.v.availability")) {
    url.searchParams.append("filter.v.availability", "1");
    link.href = url.href;
  }
}

function _uncs_getCookie(cookie_name) {
  if (!cookie_name) return '';

  let cookies = document.cookie.split(';');
  let prefix = cookie_name + "=";

  for (let c of cookies) {
    c = c.trim();
    if (c.startsWith(prefix)) {
      return c.slice(prefix.length);
    }
  }
  return '';
}

function _uncs_setCookie(cookie_name, cookie_value, exdays = 365) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cookie_name + "=" + cookie_value + ";" + expires + ";path=/";
}

function _uncs_getURLParameter(name) {
    const urlSearchParams = new URLSearchParams(window.location.search);
    var hodnota = urlSearchParams.get(name);
    return (hodnota==null) ? '' : hodnota;
}


function _uncs_LinkSlideshow() {
  
  var slides = document.querySelectorAll("div.uncs-slidelink"); //Najdi slide s třídou uncs-slidelink
  if (!slides) {
    return;
  }
  slides.forEach(slide => {
    var dataLink = slide.getAttribute("data-link");

    if (!dataLink) { return; }
    if (dataLink=="") { return; }

    slide.classList.add("uncs-pointer");
    slide.addEventListener("click", function () {
      window.location.href = dataLink;
    });

  });
}

_uncs_LinkSlideshow();
